var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.standardMap.vetted)?_c('span',[_c('font-awesome-icon',{staticClass:"text-primary",attrs:{"icon":"fa-duotone fa-shield-check"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }